import * as React from "react";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import "components/ListingActionMenu/listingActionMenu.css";

export default function IconMenu(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <div>
      <IconButton
        className="listing-action-trigger"
        aria-label="more"
        id="long-button"
        aria-controls={open ? "long-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreHorizIcon />
      </IconButton>
      <Menu
        className={`app-listing-action-menu${
          props.menuClassName ? ` ${props.menuClassName}` : ""
        }`}
        id="long-menu"
        MenuListProps={{
          "aria-labelledby": "long-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        marginThreshold={8}
        PaperProps={{ elevation: 0 }}
      >
        {React.Children.toArray(props?.row?.props?.children).map(
          (option, index) => {
            const isDisabled = option.props.children.props.disabled;
            return (
              <MenuItem
                key={index}
                onClick={isDisabled ? null : handleClose}
                style={{
                  cursor: isDisabled ? "not-allowed" : "pointer",
                  opacity: isDisabled ? 0.5 : 1,
                }}
                disabled={isDisabled}
              >
                {option}
              </MenuItem>
            );
          }
        )}
      </Menu>
    </div>
  );
}
